<template>
  <div class="panel panel-default panel-dashboard">
    <LoadingSpinner v-if="loading"/>

    <div v-else class="panel-body">
      <table class="table table-striped table-condensed">
        <thead>
        <tr>
          <th class="col-xs-7">
            Company
          </th>

          <th class="col-xs-2">
          </th>

          <th class="col-xs-4">
            User
          </th>

          <th class="col-xs-4">
            Format
          </th>

          <th class="col-xs-2">
          </th>

          <th class="col-xs-2 tw-text-right">
            Size
          </th>

          <th class="col-xs-3 tw-text-right">
            Price
          </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="publicationAd in publicationAds">
          <td class="table__ellipsis">
            <router-link :to="'/companies/'+publicationAd.attributes.company_id">
              {{ publicationAd.attributes.company_name }}
            </router-link>
          </td>

          <td>
            <div>
              <i
                  class="fa fa-link"
                  :style="{opacity: publicationAd.attributes.url ? 1 : 0.2}"
                  v-tooltip="publicationAd.attributes.url"
              />

              <i
                  class="fa fa-image"
                  :style="{opacity: publicationAd.attributes.content ? 1 : 0.2}"
                  v-tooltip="publicationAd.attributes.content"
              />

              <i
                  class="fa fa-comment"
                  :style="{opacity: publicationAd.attributes.dtp_comment ? 1 : 0.2}"
                  v-tooltip="publicationAd.attributes.dtp_comment"
              />
            </div>
          </td>

          <td>
            <router-link :to="'/users/'+publicationAd.attributes.user_id">
              {{ publicationAd.attributes.user_full_name }}
            </router-link>
          </td>

          <td>
            {{ publicationAd.attributes.publication_based_ad_format_name }}
          </td>

          <td>
            <div>
              <i
                  class="fa fa-building"
                  :style="{opacity: publicationAd.attributes.agency_commission ? 1 : 0.2}"
                  v-tooltip="publicationAd.attributes.agency_commission ? 'Agency Commission: ' + $options.filters.price(publicationAd.attributes.agency_commission) : null"
              />

              <i
                  class="fa fa-users"
                  :style="{opacity: publicationAd.attributes.third_party_costs ? 1 : 0.2}"
                  v-tooltip="publicationAd.attributes.third_party_costs ? 'Third Party Costs: ' + $options.filters.price(publicationAd.attributes.third_party_costs) : null"
              />
            </div>
          </td>

          <td class="tw-text-right">
            {{ publicationAd.attributes.publication_based_ad_format_size }}
          </td>

          <td class="tw-text-right">
            {{ publicationAd.attributes.price | price }}
          </td>
        </tr>

        <tr v-if="!publicationAds.length">
          <td colspan="8" class="text-center">
            <i>
              There are no ads to display.
            </i>
          </td>
        </tr>
        </tbody>

        <tfoot v-if="publicationAds.length">
        <tr>
          <td colspan="5" class="tw-text-right">
            Subtotal
          </td>

          <td></td>

          <td class="tw-text-right">
            {{ subTotalPrice | price }}
          </td>
        </tr>

        <tr>
          <td colspan="5" class="text-right">
            Agency Commission
          </td>

          <td></td>

          <td class="tw-text-right">
            {{ -totalAgencyCommission | price }}
          </td>
        </tr>

        <tr>
          <td colspan="5" class="text-right">
            Third Party Costs
          </td>

          <td></td>

          <td class="tw-text-right">
            {{ -totalThirdPartyCosts | price }}
          </td>
        </tr>

        <tr>
          <td colspan="5" class="text-right">
            <b>
              Total
            </b>
          </td>

          <td class="tw-text-right">
            {{ unitsSold }}
          </td>

          <td class="tw-text-right">
            <b>
              {{ totalPrice | price }}
            </b>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from '../../../../../../components/Layout/LoadingSpinner'

export default {
  components: { LoadingSpinner},

  props: {
    publication: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      publicationAds: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    unitsSold() {
      return this.publicationAds.reduce((total, publicationAd) => total + publicationAd.attributes.publication_based_ad_format_size, 0)
    },

    subTotalPrice() {
      return this.publicationAds.reduce((total, publicationAd) => total + publicationAd.attributes.price, 0)
    },

    totalAgencyCommission() {
      return this.publicationAds.reduce((total, publicationAd) => total + publicationAd.attributes.agency_commission, 0)
    },

    totalThirdPartyCosts() {
      return this.publicationAds.reduce((total, publicationAd) => total + publicationAd.attributes.third_party_costs, 0)
    },

    totalPrice() {
      return this.subTotalPrice - this.totalAgencyCommission - this.totalThirdPartyCosts
    }
  },

  methods: {
    load() {
      http.get('/api/v2/publication-based-ads', {
        'filter[publication_id]': this.publication.id
      }).then(response => {
        this.publicationAds = response.data.data

        this.loading = false
      })
    }
  }
}
</script>
